import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            热点爆料
          </h2>
          <p className="text-sm text-foreground-500">最新最热的吃瓜内容，每日持续更新</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <article className="group bg-background-50 rounded-xl border border-background-200 hover:border-accent-200 transition-all overflow-hidden cursor-pointer">
            <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20photography%20style%20image%20showing%20a%20silhouette%20of%20a%20person%20walking%20at%20night%20in%20a%20city%2C%20warm%20orange%20and%20red%20neon%20lights%2C%20mysterious%20atmosphere%2C%20magazine%20editorial%20style%2C%20soft%20shadows&width=800&height=500&seq=card-main-01&orientation=landscape"
                alt="黑料吃瓜在线 - 顶流男星深夜密会神秘女子"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-foreground-900/70 text-background-50 text-[11px] font-medium whitespace-nowrap">娱乐圈</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">某顶流男星深夜密会神秘女子，工作室紧急发声</h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-3">据知情人士透露，该男星与神秘女子在某高档餐厅共进晚餐长达三小时，期间举止亲密。</p>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span>2小时前</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line" />128万</span>
              </div>
            </div>
          </article>

          <article className="group bg-background-50 rounded-xl border border-background-200 hover:border-accent-200 transition-all overflow-hidden cursor-pointer">
            <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20clean%20studio%20photo%20of%20a%20smartphone%20showing%20a%20live%20streaming%20interface%20with%20warm%20lighting%2C%20product%20photography%20style%2C%20minimal%20background%2C%20golden%20accents&width=800&height=500&seq=card-main-02&orientation=landscape"
                alt="黑料吃瓜在线 - 知名网红直播带货翻车"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-foreground-900/70 text-background-50 text-[11px] font-medium whitespace-nowrap">网红圈</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">知名网红直播带货翻车，产品质量遭粉丝集体维权</h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-3">千万粉丝网红被曝直播间售卖的商品存在严重质量问题，目前已有多位消费者联合发起维权。</p>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span>5小时前</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line" />96万</span>
              </div>
            </div>
          </article>

          <article className="group bg-background-50 rounded-xl border border-background-200 hover:border-accent-200 transition-all overflow-hidden cursor-pointer">
            <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=An%20artistic%20abstract%20composition%20representing%20entertainment%20and%20media%20with%20warm%20red%20and%20orange%20gradients%2C%20geometric%20shapes%2C%20editorial%20magazine%20cover%20style%2C%20sophisticated&width=800&height=500&seq=card-main-03&orientation=landscape"
                alt="黑料吃瓜在线 - 综艺节目录制现场突发意外"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-foreground-900/70 text-background-50 text-[11px] font-medium whitespace-nowrap">综艺</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">某综艺节目录制现场突发意外，节目组紧急暂停拍摄</h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-3">据悉该节目为一档竞技类真人秀，录制过程中一名嘉宾不慎受伤，目前已被送往医院。</p>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span>8小时前</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line" />85万</span>
              </div>
            </div>
          </article>

          <article className="group bg-background-50 rounded-xl border border-background-200 hover:border-accent-200 transition-all overflow-hidden cursor-pointer">
            <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20photograph%20of%20a%20luxury%20brand%20storefront%20at%20night%20with%20warm%20golden%20lighting%2C%20reflective%20surfaces%2C%20modern%20architecture%2C%20editorial%20photography%20with%20dramatic%20shadows&width=800&height=500&seq=card-main-04&orientation=landscape"
                alt="黑料吃瓜在线 - 知名品牌广告涉抄袭争议"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-foreground-900/70 text-background-50 text-[11px] font-medium whitespace-nowrap">社会</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2">知名品牌广告涉抄袭争议，官方回应引网友不满</h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-3">该品牌最新广告片被指抄袭某独立设计师作品，品牌方面回应称纯属巧合，但网友并不买账。</p>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span>12小时前</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line" />73万</span>
              </div>
            </div>
          </article>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-5">
          <article className="group flex flex-col sm:flex-row bg-background-50 rounded-xl border border-background-200 hover:border-accent-200 transition-all overflow-hidden cursor-pointer">
            <div className="relative w-full sm:w-[180px] aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-100 flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=An%20elegant%20editorial%20portrait%20style%20image%20with%20soft%20warm%20lighting%2C%20minimal%20makeup%2C%20natural%20look%2C%20neutral%20beige%20background%2C%20magazine%20beauty%20editorial%20style&width=800&height=500&seq=card-sub-01&orientation=landscape"
                alt="黑料吃瓜在线 - 某女星现身机场素颜照曝光"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 flex flex-col justify-center flex-1 min-w-0">
              <span className="text-[11px] text-accent-600 font-medium mb-1 whitespace-nowrap">娱乐圈</span>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1.5 line-clamp-2">某女星现身机场素颜照曝光，网友直呼认不出</h3>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span>1天前</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line" />68万</span>
              </div>
            </div>
          </article>

          <article className="group flex flex-col sm:flex-row bg-background-50 rounded-xl border border-background-200 hover:border-accent-200 transition-all overflow-hidden cursor-pointer">
            <div className="relative w-full sm:w-[180px] aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-100 flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20film%20set%20scene%20with%20warm%20lighting%2C%20camera%20equipment%20silhouettes%2C%20atmospheric%20haze%2C%20cinematic%20mood%2C%20golden%20hour%20tones%2C%20editorial%20style&width=800&height=500&seq=card-sub-02&orientation=landscape"
                alt="黑料吃瓜在线 - 热门网剧导演被爆拖欠剧组工资"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 flex flex-col justify-center flex-1 min-w-0">
              <span className="text-[11px] text-accent-600 font-medium mb-1 whitespace-nowrap">影视</span>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1.5 line-clamp-2">热门网剧导演被爆拖欠剧组工资，剧组工作人员集体讨薪</h3>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span>1天前</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line" />55万</span>
              </div>
            </div>
          </article>

          <article className="group flex flex-col sm:flex-row bg-background-50 rounded-xl border border-background-200 hover:border-accent-200 transition-all overflow-hidden cursor-pointer">
            <div className="relative w-full sm:w-[180px] aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-100 flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20photograph%20of%20a%20stage%20with%20dramatic%20warm%20spotlight%2C%20empty%20auditorium%2C%20golden%20and%20amber%20lighting%2C%20theatrical%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=card-sub-03&orientation=landscape"
                alt="黑料吃瓜在线 - 某选秀节目选手背景造假被扒"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 flex flex-col justify-center flex-1 min-w-0">
              <span className="text-[11px] text-accent-600 font-medium mb-1 whitespace-nowrap">选秀</span>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1.5 line-clamp-2">某选秀节目选手背景造假被扒，节目组表示将严肃处理</h3>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span>2天前</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line" />42万</span>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}